export const ACCOUNT_SETTLEMENT_CONTINUATION_RESET = 'ACCOUNT_SETTLEMENT_CONTINUATION_LIST_RESET'
export const ACCOUNT_SETTLEMENT_CONTINUATION_SET_ITEMS = 'ACCOUNT_SETTLEMENT_CONTINUATION_LIST_SET_ITEMS'
export const ACCOUNT_SETTLEMENT_CONTINUATION_SET_ERROR = 'ACCOUNT_SETTLEMENT_CONTINUATION_LIST_SET_ERROR'
export const ACCOUNT_SETTLEMENT_CONTINUATION_SET_VIEW = 'ACCOUNT_SETTLEMENT_CONTINUATION_LIST_SET_VIEW'
export const ACCOUNT_SETTLEMENT_CONTINUATION_TOGGLE_LOADING = 'ACCOUNT_SETTLEMENT_CONTINUATION_LIST_TOGGLE_LOADING'
